import { types } from "../types/types";
const intitalState = {
    allReplacement: [],
};

const replacementReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.CHANGE_REPLCAMENT:
            return {
                ...state,
                allReplacement: action.payload,
            };
        default:
            return { ...state };
    }
};

export default replacementReducer;
